function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 9.875,
  y: 6.43767,
  width: 11.8125,
  height: 12.625,
  rx: 1,
  fill: "#4A8D5C",
  stroke: "#4A8D5C",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4 6.48518C4 5.49952 4.71812 4.66081 5.69203 4.50903L13.067 3.35968C14.2797 3.17069 15.375 4.10848 15.375 5.33583V20.1642C15.375 21.3915 14.2797 22.3293 13.067 22.1403L5.69203 20.991C4.71812 20.8392 4 20.0005 4 19.0148V6.48518Z",
  fill: "#4A8D5C",
  stroke: "white",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.36187 12.4218L8.3756 10.6726C8.3182 10.5719 8.26602 10.4712 8.21905 10.3704C8.17991 10.288 8.14338 10.201 8.10947 10.1094C8.07816 10.0178 8.0625 9.93999 8.0625 9.87588C8.0625 9.79346 8.08207 9.70951 8.12121 9.62403C8.16295 9.53856 8.23471 9.46072 8.33646 9.39051C8.45388 9.31724 8.56085 9.28061 8.65739 9.28061C8.73045 9.28061 8.79699 9.30045 8.857 9.34014C8.91962 9.37677 8.97571 9.42714 9.02529 9.49124C9.07747 9.5523 9.12574 9.62251 9.1701 9.70188C9.21445 9.78125 9.25751 9.86062 9.29925 9.93999L10.0272 11.3412H10.1446L10.8726 9.93999C10.9143 9.86062 10.9574 9.78125 11.0017 9.70188C11.0461 9.62251 11.0931 9.5523 11.1426 9.49124C11.1948 9.42714 11.2509 9.37677 11.3109 9.34014C11.3709 9.30045 11.4388 9.28061 11.5145 9.28061C11.5614 9.28061 11.611 9.29129 11.6632 9.31266C11.718 9.33403 11.7754 9.36303 11.8354 9.39966C11.945 9.46987 12.0206 9.54619 12.0624 9.62861C12.1041 9.70798 12.125 9.78735 12.125 9.86672C12.125 9.93388 12.108 10.0132 12.0741 10.1048C12.0402 10.1964 12.0024 10.2849 11.9606 10.3704C11.9137 10.4712 11.8589 10.5719 11.7962 10.6726L10.8178 12.4218V12.5042L11.9058 14.5098C11.9606 14.6106 12.0076 14.7113 12.0467 14.812C12.0885 14.9097 12.1093 15.0074 12.1093 15.1051C12.1093 15.1875 12.0898 15.2699 12.0506 15.3524C12.0141 15.4317 11.945 15.5081 11.8432 15.5813C11.7258 15.6546 11.6188 15.6912 11.5223 15.6912C11.4544 15.6912 11.3931 15.676 11.3383 15.6454C11.2835 15.6118 11.2327 15.5691 11.1857 15.5172C11.1387 15.4653 11.0944 15.4058 11.0526 15.3386C11.0135 15.2715 10.9743 15.2028 10.9352 15.1326L10.1446 13.6307H10.0272L9.23663 15.1326C9.1975 15.2028 9.15705 15.2715 9.11531 15.3386C9.07617 15.4058 9.03312 15.4653 8.98615 15.5172C8.9418 15.5691 8.89222 15.6118 8.83743 15.6454C8.78263 15.676 8.72262 15.6912 8.65739 15.6912C8.55825 15.6912 8.45388 15.6546 8.34429 15.5813C8.23732 15.5081 8.16295 15.4317 8.12121 15.3524C8.08207 15.2699 8.0625 15.1875 8.0625 15.1051C8.0625 15.0074 8.08207 14.9097 8.12121 14.812C8.16295 14.7113 8.21122 14.6106 8.26602 14.5098L9.36187 12.5042V12.4218Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.375 10.3126H21.0625",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.4375 7.06239L19.4375 18.4374",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M15.375 15.1875H21.0625",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var SvgExcelHover = function SvgExcelHover(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExcelHover, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/excelHover.db7ab6f0.svg";
export { ForwardRef as ReactComponent };